export default __webpack_public_path__ + "static/media/logo7.37c64056.webp";